import { GetFlightGroupsResponse } from '@orbit/api-types'
import api from '@lib/api'
import { queryKeys } from '@lib/queryKeys'
import { useQuery } from '@tanstack/react-query'

export const useFlights = (tripId: string | undefined) => {
	return useQuery<GetFlightGroupsResponse>({
		queryKey: queryKeys.flights(tripId),
		queryFn: async () => {
			if (!tripId) {
				throw new Error('Trip ID is required')
			}
			const response = await api.get<GetFlightGroupsResponse>(`/trips/${tripId}/flights/`)
			return response.data
		},
		enabled: !!tripId,
		retry: 1,
	})
}
